import { TRANSPORT_URL } from "./config";
import { bus } from "@/main.js";
import * as io from "socket.io-client";

class Transport {
    constructor() {}
    
    init() {
        this.socket = io(TRANSPORT_URL, {
            query: {
                token: localStorage.getItem("token"),
                identity: JSON.stringify({
                    domain: "docsmart",
                    device: "web"
                })
            }
        });
        this.socket.on("connect", () => {
            console.log(`Transport connected on ${TRANSPORT_URL}`);
            this.socket.on("action", payload => {
                console.log("Transport payload", payload);
                this.registerActions(payload);
            });
        });
        this.socket.on("disconnect", reason => {
            if (reason === "io server disconnect") {
                console.log("Disconnected from Transport server");
            } else {
                console.log("Transport Unexpectedly Disconnected", reason);
            }
            this.socket.off("action");
        });
    }

    close() {
        console.log("Transport Disconnecting Manually");
        if(this.socket) this.socket.disconnect();
    }

    registerActions(payload) {
        let currRole = localStorage.getItem("currentRole");
        if (!payload.role || payload.role == currRole){
            bus.$emit(payload.type, payload);
        }
    }
}

export default new Transport();